module.exports = __webpack_public_path__ + "assets/images/pages/kfc/kfc-1.png?a8072f9d";